import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {handleError} from "../lib/errorHandler.js";
import {localeMessage} from "../lib/i18n.js";
export const formatMessage = (info) => {
  let local = localStorage.getItem("language") || "id";
  return localeMessage[local][info.id];
};
export const usePermissions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (value) => {
    setLoading(true);
    try {
      const data2 = value ? value : JSON.parse(localStorage.getItem("permissions") || "[]");
      setData(data2);
      return {
        permissions: data2
      };
    } catch (error) {
      handleError(error);
      return {
        permissions: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    permissionsLoading: loading,
    permissions: data,
    fetchPermissions: fetchData
  };
};
export const usePermissionsModel = createModel(usePermissions);
